import reducers from "./resetPasswordReducers";

export default reducers;
